import { apiJson } from "./client";
import type { TourPapers } from "../state/tourStore";

interface SetupResponse {
  projectId: number;
  papers: TourPapers;
}

interface PaperStatusSnap {
  status: string;
}

export async function setupTour(): Promise<SetupResponse> {
  return apiJson<SetupResponse>("/api/tour/setup", { method: "POST" });
}

export async function cleanupTour(): Promise<void> {
  await apiJson("/api/tour/cleanup", { method: "DELETE" });
}

/** Poll until the paper is no longer queued/processing (max 3 minutes). */
export async function waitForTourPaper(paperId: number): Promise<void> {
  const deadline = Date.now() + 180_000;
  while (Date.now() < deadline) {
    try {
      const snap = await apiJson<PaperStatusSnap>(`/api/papers/${paperId}/status`);
      if (snap.status !== "queued" && snap.status !== "staged" && snap.status !== "processing") return;
    } catch {
      // transient error — keep polling
    }
    await new Promise((r) => setTimeout(r, 2_500));
  }
}
